import { render, staticRenderFns } from "./ApplicationStateBadge.vue?vue&type=template&id=529d2971&scoped=true"
import script from "./ApplicationStateBadge.vue?vue&type=script&lang=ts"
export * from "./ApplicationStateBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529d2971",
  null
  
)

export default component.exports